const file_upload_rules = {
  sizeLimit: 25000000,
  acceptedTypes: [
    'text/xml',
    'application/xml',
    'image/jpeg',
    'image/png',
    'application/pdf',
    'audio/mp3',
    'audio/wav',
    'application/zip',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  ],
  acceptedImageTypes: ['image/jpeg', 'image/png'],
};

export default file_upload_rules;
